// i18n area 'vms' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.ru-RU.meta.json.
import type { enUS } from './vms'

export const ruRU: typeof enUS = {
  vms: {
    spof: {
      title: 'Независимость от узла',
      single: 'Единая точка отказа',
      alternativesNow: 'Альтернативы сейчас',
      structural: 'По конструкции',
      binding: 'Ограничивающее условие',
      movableNow: 'Миграция возможна сейчас',
    },
    title: 'Виртуальные машины',
    migratingChip: 'Идет миграция',
    templateChip: 'Шаблон',
    expendableTooltip: 'В деградировавшем кластере она среди первых, кого останавливают, и может не перезапуститься после потери узла.',
    expendableHaTooltip: 'Всегда перезапускается, пока кластер здоров; в деградировавшем кластере защищённые ВМ идут первыми — её могут остановить или она останется выключенной, пока кластер снова не станет целым, затем возвращается сама.',
    viewDetails: 'Смотреть детали',
    profileLegacy: 'Другая ОС',
    hugePagesNone: 'Нет — обычная память',
    hugePages2M: 'Страницы по 2 MiB',
    hugePages1G: 'Страницы по 1 GiB',
    searchPlaceholder: 'Поиск по имени',
    name: 'Имя',

    // Единая терминология (#94a): фаза везде называется «Фаза» — старый
    // ключ 'state' умер вместе с полировкой списка.
    vcpus: 'vCPU',
    memory: 'Память',
    ipAddresses: 'IP-адреса',
    noIp: 'Нет IP',
    authorityNode: 'Ответственный узел',
    authorityNextStart: 'назначается при следующем запуске',
    scope: 'Скоуп',
    empty: 'Виртуальных машин нет',
    loadError: 'Не удалось загрузить виртуальные машины — доступен ли бэкенд TVirt?',
    filterOverlay: 'оверлейная сеть',
    filterDisk: 'диск',
    filterImage: 'образ',
    filteredBy: 'Отфильтровано по: {kind}',
    filterPhase: 'Фаза',
    filterProtection: 'Защита',
    filterAll: 'Все',
    filterScopePlaceholder: 'Фильтр по скоупу',
    filtersToggle: 'Фильтры',
    scopeTree: {
      title: 'Скоупы',
      all: 'Весь кластер',
      noChildren: 'Здесь нет вложенных скоупов',
      recursive: 'Включая вложенные',
      collapse: 'Свернуть панель скоупов',
      up: 'На уровень выше',
      countTooltip: '{direct} ВМ в этом скоупе · {total} с вложенными'
    },

    // Двухшаговый выбор ISO (#85): сначала каталог, затем его образы ISO.
    isoPicker: {
      catalog: 'Каталог',
      unknownCatalog: 'Вне видимых каталогов',
      noIsos: 'В этом каталоге нет готовых образов ISO'
    },
    actionsHeader: 'Действия',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Оборудование',
      tags: 'Теги',
      age: 'Возраст',
      disk: 'диск',
      disks: 'дисков',
      empty: 'Шаблонов нет — отметьте выключенную ВМ как шаблон или клонируйте ВМ в шаблон.',
      clone: 'Клонировать / развернуть',
      editTags: 'Изменить теги',

      // Раунд K3 (#64): экспорт шаблона как файла .tvtpl в каталог.
      exportAction: 'Экспорт в каталог (.tvtpl)',
      exportTitle: 'Экспорт в каталог',
      exportSubmit: 'Экспортировать',
      exportError: 'Экспорт не удался',
      exportHint: 'Шаблон упаковывается в архив .tvtpl (манифест оборудования плюс каждый диск, сплющенный в qcow2) как новый файл «Шаблон ВМ» в выбранном каталоге. NIC, носители CD/DVD и cloud-init с ним не едут — спецификация формата перечисляет каждое намеренное упущение.',
      exportName: 'Имя файла',
      exportNameHint: 'Пусто = <шаблон>-export-<n>',
      exportStorageDefault: 'Хранилище метаданных шаблона',

      // Импорт из каталога (Luca 2026-08-03): вход на панели инструментов
      // вкладки шаблонов — бэкенд K3/K4 покрывает все форматы vm-template,
      // выбирается ФАЙЛ (формат едет только на чтение).
      importAction: 'Импорт из каталога',
      importTitle: 'Импорт из каталога',
      importHint: 'Готовый файл «Шаблон ВМ» из выбранного каталога становится шаблоном инвентаря: формат файла (tvtpl, ova, ovf или голый qcow2) сам решает, как пройдет импорт — вы выбираете только файл.',
      importFile: 'Файл каталога',
      importFileHint: 'Импортируются только готовые файлы — файл на середине отправки импортировать нельзя',
      importNoFiles: 'В этом каталоге нет готовых файлов «Шаблон ВМ» — сначала загрузите или экспортируйте один'
    },
    templateDetail: {
      quickDeploy: 'Совместимость с QuickDeploy',
      quickDeployNone: 'Не декларирована',
      quickDeployHint: 'Декларируйте её только если golden-образ содержит cloud-init (Linux) или cloudbase-init после sysprep /generalize (Windows): платформа доверяет декларации и никогда не заглядывает внутрь гостя.',
      notFound: 'Шаблон не найден',
      frozen: 'Конфигурация оборудования заморожена: чтобы изменить ее, превратите шаблон обратно в ВМ. Имя, заметки и теги остаются изменяемыми.',
      storage: 'Хранилище',
      size: 'Размер',
      configTitle: 'Конфигурация (заморожена)',
      usbClasses: 'Требуемые классы USB',
      gpuClasses: 'Требуемые классы GPU'
    },
    sharedDisksTab: {
      title: 'Общие диски',
      sharing: 'Совместное использование',
      sharingNone: 'Одно подключение',
      sharingMultiwriter: 'Общая запись (multiwriter)',
      sharingReadonly: 'Общее только чтение',
      usedBy: 'Используется',
      attachedTo: 'Подключён к',
      notAttached: 'Не подключён ни к одной VM',
      changeSharing: 'Изменить режим совместного использования',
      changeSharingTitle: 'Режим совместного использования',
      changeSharingLocked: 'Режим меняется, только пока диск не использует ни одна VM',
      sharingChanged: 'Режим совместного использования обновлён.',
      lun: 'Целый LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Серийный номер',
      antiAffinityWarning: 'Два или более участника работают на одном узле без правила анти-аффинности: отказ одного узла уронит всех',
      antiAffinityCreate: 'Создать правило',
      createSourceLun: 'Принять целый LUN таргета',
      createLunNumber: 'Номер LUN (id namespace на NVMe)',
      createLunHint: 'Ничего не выделяется: размер считывается с устройства при принятии',
      noPr: 'В этом выпуске нет SCSI-3 persistent reservations: Windows Failover Cluster с классическим общим диском не валидирован; кластеры, координирующиеся по сети (GFS2/OCFS2, RHEL HA, базы shared-disk), — да'
    },
    unusedDisksTab: {
      title: 'Неиспользуемые диски',
      attach: 'Подключить к ВМ',
      attachTitle: 'Подключение к ВМ',
      vm: 'Виртуальная машина',
      noVms: 'Доступных ВМ нет',
      noSlots: 'На этой ВМ нет свободных слотов',

      // Создание самостоятельного диска (#87): вернулось из упраздненного
      // инвентаря, теперь с ЯВНЫМ полем скоупа (наследовать не от кого).
      create: 'Создать диск',
      createTitle: 'Создание диска',
      createSourceBlank: 'Пустой диск',
      createSourceImage: 'Из образа в каталоге',
      createImage: 'Образ',
      createImageEmpty: 'В видимых каталогах нет готового образа шаблона ВМ',
      createSizeFromImageHint: 'Предзаполнено виртуальным размером образа — может только расти',

      // #107 (РАЗРУШИТЕЛЬНО, ратифицировано): qcow2 → файл каталога
      // vm-template в том же хранилище, ноль скопированных байтов — диск
      // перестает существовать.
      convert: 'Преобразовать в шаблон ВМ…',
      convertOnlyQcow2: 'Преобразуются только диски qcow2 — raw не является регистрируемым форматом шаблона',
      convertTitle: 'Преобразование в шаблон ВМ',
      convertSubmit: 'Преобразовать (диск будет уничтожен)',
      convertError: 'Не удалось запустить преобразование',
      convertWarning: 'РАЗРУШИТЕЛЬНО: диск становится файлом шаблона ВМ в выбранном каталоге — то же хранилище, ноль скопированных байтов — и ПЕРЕСТАЕТ СУЩЕСТВОВАТЬ как диск. Обратного пути нет, кроме создания нового диска из шаблона.',
      convertNameHint: 'Имя файла каталога — по умолчанию имя диска',
      convertConfirm: 'Я понимаю: диск будет уничтожен',
      convertStarted: 'Преобразование запущено — шаблон появится в каталоге по завершении задачи.',
      storageLockHint: 'Хранилище меняется только действием «Переместить»',
      source: 'Происхождение',
      sourceClone: 'Клон другого диска',
      sourceCloneLinked: 'Связанный клон другого диска',
      sourceImage: 'Создан из образа',
      sourceBlank: 'Создан пустым',
      allocated: 'Выделено / виртуальный размер',
      observedAt: 'Дата наблюдения',
      snapshots: 'Снимки',
      snapshotsEmpty: 'Снимков нет'
    },
    phase: {
      defined: 'Ни разу не включалась',
      starting: 'Запускается',
      running: 'Работает',
      stopping: 'Останавливается',
      stopped: 'Выключена',
      paused: 'На паузе',
      failed: 'В ошибке',
      deleting: 'Удаляется'
    },
    stopCause: {
      'api': 'Остановлена платформой TVirt (действие или API)',
      'guest-shutdown': 'Выключение начато гостевой операционной системой',
      'crash': 'Сбой гостевой системы',
      'qemu-exit': 'Процесс QEMU завершился неожиданно',
      'host-reboot': 'Узел был перезагружен',
      'migrated': 'Мигрировала на другой узел',
      'fenced': 'Завершена фенсингом HA (узел вернулся)'
    },
    detail: {
      notFound: 'Виртуальная машина не найдена',
      details: 'Детали',
      id: 'ID',
      scope: 'Скоуп',
      profile: 'Профиль оборудования',
      firmware: 'Прошивка',
      firmwareFile: 'Версия прошивки UEFI',
      firmwareUpdate: 'Доступно обновление',
      firmwareUpdateHint: 'Платформа поставляет более новую прошивку UEFI. Обновление никогда не выполняется автоматически: оно применяется на выключенной ВМ, когда ты так решишь.',
      arch: 'Архитектура',
      node: 'Узел',
      bootOrder: 'Порядок загрузки',
      agent: 'Состояние агента',
      agentConnected: 'Подключен',
      agentNotConnected: 'Не подключен',
      protected: 'Защищена',
      linkedClones: 'Связанные клоны',
      restartPolicy: 'Политика перезапуска',
      preferredNode: 'Предпочитаемый узел',
      noPreference: 'Без предпочтения (автоматическое размещение)',
      preferNodes: 'Предпочитаемые теги узла',
      requireNodes: 'Обязательные теги узла',
      noPlacementTags: 'Нет',
      placementTag: 'Тег',
      placementValue: 'Значение',
      placementAddTag: 'Добавить тег',
      proximityHa: 'HA от TVirt Proximity',
      proximityHaRestarts: 'перезапусков HA',
      proximityHaGaveUp: 'цикл сбоев — HA сдался',
      failoverProtection: 'Защита в деградировавшем кластере',
      protectionProtected: 'Защищённая',
      protectionExpendable: 'Жертвуемая при деградации',
      protectionInherit: 'Наследовать',
      lastStop: 'Последняя остановка',
      yes: 'Да',
      no: 'Нет',
      tabOverview: 'Обзор',
      tabSnapshots: 'Снимки',
      tabBackups: 'Копии',
      hardware: 'Оборудование',
      name: 'Имя',
      hwSystem: 'Система',
      hwCpu: 'CPU',
      hwMemory: 'Память',
      hwBoot: 'Загрузка',
      hwIdentity: 'Идентичность',
      hwCluster: 'Кластер и агент',
      cpuTopology: 'Топология CPU',
      cpuModel: 'Модель CPU',
      cpuLimit: 'Лимит CPU',
      cpuWeight: 'Вес CPU',
      cpuNested: "Вложенная виртуализация",
      cpuNestedHint: "Открывает гостю vmx/svm (только с моделью CPU host). На работающей ВМ изменение вступит в силу при следующем power cycle (PendingRestart); размещение допускает только узлы с включённым nested.",
      unlimited: 'Без ограничения',
      memory: 'Память',
      balloon: 'Балун',
      hugePages: 'Огромные страницы',
      hugePagesTradeoff: 'Меньше работы по трансляции адресов и память, которая никогда не уходит на диск; взамен резервирование остаётся закреплённым за узлом, пока ВМ работает, память больше не дедуплицируется, а старт срывается, если на узле слишком мало свободных страниц.',
      disks: 'Диски',
      cdroms: 'Приводы CD/DVD',
      nics: 'Сетевые интерфейсы',
      slot: 'Слот',
      disk: 'Диск',
      encrypted: 'Зашифрован',
      image: 'Образ',
      emptyDrive: 'Пустой привод',
      emptyOption: '(пусто)',
      network: 'Сеть',
      mac: 'MAC',
      connected: 'Подключена',
      unplugged: 'Отключена',
      noDevices: 'Нет',
      screenshot: 'Снимок экрана',
      capturedAt: 'Снято в',
      noCapture: 'Снимок не сделан',
      snapshotName: 'Имя',
      snapshotCreated: 'Создан',
      snapshotMemory: 'Память включена',
      noSnapshots: 'Снимков нет',
      pendingRestart: 'Изменения ожидают: они применятся при следующем цикле питания.',
      applied: 'применено',
      appliedHint: 'ВМ работает с этим значением — настроенное применится при следующем цикле питания.',
      actionError: 'Действие не удалось',
      actionStillRunning: 'Действие ещё выполняется — результат пока неизвестен',
      tabConsole: 'Консоль',
      consoleConnect: 'Подключиться',
      consoleDisconnect: 'Отключиться',
      consoleConnecting: 'Подключение…',
      consoleReconnecting: 'Подключение…',
      consoleUnavailable: 'Консоль доступна, когда ВМ работает или стоит на паузе.',
      consoleError: 'Не удалось подключиться к консоли',
      consoleTaken: 'Сессию консоли занял пользователь {user}',
      consoleReconnect: 'Переподключиться',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Удерживать {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Открыть на весь экран в новой вкладке',
      consoleLoadFailed: 'ВМ не найдена или недостаточно прав',
      consoleClose: 'Закрыть',
      tabStats: 'Статистика',
      tabTasks: 'Задачи',
      tabLogs: 'Журнал',
      statsCpu: 'CPU',
      statsMemory: 'Память',
      statsDisk: 'Ввод-вывод диска',
      statsRange: 'Интервал',
      statsNoData: 'В интервале нет данных — статистика снимается, пока ВМ работает.',
      statsError: 'Не удалось загрузить статистику',
      cpuUsage: 'Использование',
      cpuReady: 'Готовность (%RDY)',
      memUsed: 'Занято',
      memGuestAvailable: 'Доступно (гость)',
      schema: 'Схема',
      consoleProtocol: 'Консоль',
      agentEnabled: 'Гостевой агент',
      metadataStorage: 'Хранилище метаданных',
      startupOnBoot: 'Запуск при загрузке узла',
      startupOrder: 'Порядок запуска',
      startupDelay: 'Задержка запуска',
      seconds: 'с',
      enabled: 'Включено',
      disabled: 'Выключено'
    },
    actionsAvailable: 'Доступные действия',
    actions: {
      start: 'Запустить',
      stop: 'Остановить',
      pause: 'Пауза',
      resume: 'Возобновить',
      reset: 'Сбросить',
      migrate: 'Мигрировать',
      clone: 'Клонировать',
      moveStorage: 'Переместить в хранилище…',
      moveScope: 'Переместить в скоуп…',
      openConsole: 'Открыть консоль',
      forceStop: 'Принудительное выключение',
      markTemplate: 'Отметить как шаблон',
      unmarkTemplate: 'Превратить обратно в ВМ',
      error: 'Не удалось выполнить действие'
    },
    cordon: {
      confirmTitle: 'Узел в режиме обслуживания',
      confirmHint:
        'Кордон нельзя опустить, пока хранилище кластера недоступно. Подтверждая, вы заявляете, что знаете об этом: ВМ всё равно запустится там, а согласие останется записанным в задаче.',
      confirm: 'Всё равно запустить'
    },
    markTemplate: {
      confirmTitle: 'Отметить {name} как шаблон?',
      confirmBody: 'Конфигурация замораживается, и ВМ больше не сможет включаться — только клонироваться или снова стать ВМ. Имя, заметки и теги остаются изменяемыми.',
      confirm: 'Отметить как шаблон',
      moved: '{name} теперь шаблон — запись переехала на вкладку шаблонов.'
    },
    unmarkTemplate: {
      confirmTitle: 'Превратить {name} обратно в ВМ?',
      confirmBody: 'Шаблон снова становится обычной ВМ: изменяемой и запускаемой (следующий запуск разместит ее на узле).',
      confirm: 'Превратить обратно в ВМ',
      moved: '{name} снова виртуальная машина — запись переехала на вкладку виртуальных машин.'
    },

    // Раунд #123: ссылка на узел по ТЕГУ (селектор #106) в диалогах запуска
    // и миграции — с предпросмотром разрешенного набора.
    nodeByTag: {
      label: 'По тегу узла',
      hint: 'тег=значение, через запятую (по логическому И): выбор делается среди подходящих узлов',
      invalid: 'Неверный формат — используйте тег=значение, через запятую',
      resolved: 'Подходящие участники: {nodes}'
    },
    migrate: {
      title: 'Живая миграция',
      submit: 'Мигрировать',
      target: 'Узел назначения',
      auto: 'Автоматически (Proximity)',
      hint: 'ВМ переезжает без цикла питания. Каждое хранилище, которого она касается, должно быть общим; ВМ на паузе мигрирует на паузе.',
      error: 'Миграция отклонена'
    },
    moveStorage: {
      title: 'Перемещение в хранилище',
      submit: 'Переместить',
      target: 'Хранилище назначения',
      noTargets: 'Ни одно хранилище не принимает диски',
      hint: 'Все диски выключенной ВМ переезжают в выбранное хранилище по одному, сохраняя свой id — те, что уже на месте назначения, пропускаются. Прогресс живет на странице задач.',
      error: 'Перемещение отклонено'
    },
    moveScope: {
      title: 'Перемещение в скоуп',
      submit: 'Переместить',
      target: 'Скоуп назначения',
      hint: 'ВМ меняет скоуп немедленно — id и диски остаются, принадлежащие ей диски следуют за ней, и она может оставаться включенной. Сейчас она живет в {scope}. Круг тех, кто ее видит, меняется вместе со скоупом.',
      error: 'Перемещение в другой скоуп отклонено'
    },
    start: {
      title: 'Запустить ВМ',
      submit: 'Запустить',
      target: 'Узел назначения',
      auto: 'Автоматически (рекомендуется)',
      recommended: 'рекомендуется',
      hint: 'Выберите узел назначения или дайте решить Proximity среди подходящих кандидатов. Узлы, которые не могут ее принять, отключены с указанием причины.',
      error: 'Не удалось запустить ВМ'
    },
    console: {
      media: 'Приводы CD/DVD',
      mediaGuestToolsHint: 'Содержит TVirt Guest Tools — отсюда вы можете их извлечь или убрать привод',
      slotOpsDeferred: 'На этом профиле добавление и снятие приводов применяются при следующем цикле питания (смена носителя происходит сразу).',
      mountGuestTools: 'Смонтировать TVirt Guest Tools',
      ejectGuestTools: 'Извлечь TVirt Guest Tools',
      bootOrder: 'Порядок загрузки',
      bootOrderHint: 'Новый порядок сохраняется сразу и применяется при следующем цикле питания — сессия консоли остается подключенной.'
    },
    snapshots: {
      create: 'Создать снимок',
      createTitle: 'Создание снимка',
      createSubmit: 'Создать',
      name: 'Имя',
      nameHint: 'Буквы, цифры, точка, дефис, подчеркивание.',
      consistencyHint: 'Согласованность обеспечивается автоматически: гостевой агент замораживает файловые системы, когда отвечает; иначе ВМ на мгновение уходит в паузу вокруг снимка.',
      memory: 'Включить память',
      memoryHint: 'Захватывает живую RAM: восстановление возобновляет ВМ работающей. Требует, чтобы все диски были qcow2.',
      currentChip: 'Вы здесь',
      revert: 'Восстановить',
      revertTitle: 'Восстановить {name}?',
      revertBody: 'Диски возвращаются к состоянию снимка; все, что произошло после, теряется. Снимок только дисков требует остановленной ВМ.',
      delete: 'Удалить',
      deleteTitle: 'Удалить снимок {name}?',
      deleteBody: 'Точка восстановления исчезает; содержимое дисков остается нетронутым.',
      deleteMergeHint: 'Его дельта сливается в {children}: каждая последующая точка восстановления остается действительной.',
      deleteDuplication: 'Принимаю дублирование',
      deleteDuplicationHint: 'Дельта копируется в каждый из {count} читателей (дочерние snapshot и, если этот является текущим, активную голову): занятое место может вырасти вместо того, чтобы уменьшиться.',
      error: 'Операция со снимком отклонена'
    },
    clone: {
      title: 'Клонировать ВМ',
      submit: 'Клонировать',
      name: 'Имя копии',
      storage: 'Хранилище назначения для дисков',
      sameStorage: 'То же, что у источника',
      full: 'Полная копия',
      fullHint: 'Копирует каждый байт и разрывает связь с исходными дисками. По умолчанию делается связанный клон: мгновенный, но прикованный к источнику (только qcow2).',
      hint: 'Клон сохраняет конфигурацию и прошивку источника; MAC-адреса и идентичность TPM создаются заново.',
      markAs: 'Тип клона',
      markAsInheritVm: 'Как у источника (ВМ)',
      markAsInheritTemplate: 'Как у источника (шаблон)',
      markAsVm: 'Виртуальная машина',
      markAsTemplate: 'Шаблон',
      markAsHintVm: 'Выберите «Шаблон», чтобы повысить копию за один шаг.',
      markAsHintTemplate: 'Выберите «Виртуальная машина», чтобы развернуть из этого шаблона за один шаг.',
      error: 'Клонирование отклонено'
    },
    bulk: {
      selected: 'выбрано',
      deleteTitle: {
        one: 'Удалить {count} выбранную ВМ?',
        few: 'Удалить {count} выбранные ВМ?',
        many: 'Удалить {count} выбранных ВМ?',
        other: 'Удалить {count} выбранной ВМ?'
      },
      deleteBody: 'Каждая ВМ проходит те же проверки, что и одиночное удаление; отказы показываются по каждому элементу.',
      done: 'принято',
      refused: 'отклонено'
    },
    delete: {
      button: 'Удалить',
      confirmTitle: 'Удалить {name}?',
      confirmBody: 'Виртуальная машина и принадлежащие ей диски будут удалены. Операция необратима.',
      keepDisks: 'Сохранить диски',
      keepDisksHint: 'Диски, созданные вместе с ВМ, остаются в своем хранилище как самостоятельные диски.',
      confirm: 'Удалить',
      cancel: 'Отмена',
      error: 'Удаление не удалось',
      blockedPhase: 'Сначала остановите ВМ',
      blockedProtected: 'ВМ защищена — сначала снимите защиту',
      blockedDeleting: 'Удаление уже идет'
    },
    logs: {
      title: 'Журнал',
      subtitle: 'Структурированные кадры журнала от задач, затрагивающих эту ВМ',
      when: 'Когда',
      task: 'Задача',
      level: 'Уровень',
      message: 'Сообщение',
      empty: 'Записей журнала пока нет',
      loadError: 'Не удалось загрузить журнал — доступен ли бэкенд TVirt?'
    },
    stop: {
      title: 'Остановить виртуальную машину',
      modeGraceful: 'Штатное выключение',
      modeGracefulHint: 'Гостевой операционной системе предлагается выключиться штатно (ACPI); если она игнорирует запрос, по истечении таймаута срабатывает принудительное выключение.',
      modeForced: 'Принудительное выключение',
      modeForcedHint: 'Мгновенно снимает питание, как выдернуть вилку из розетки.',
      timeout: 'Таймаут перед запасным вариантом (секунды)',
      timeoutHint: 'Сколько ждать гостя перед принудительным выключением'
    },

    // Меню кнопки создания с раздельными действиями (Luca 2026-07-23):
    // «С нуля» открывает мастер, две другие записи — заглушки дорожной карты.
    createFromScratch: 'С нуля',
    createFromTemplate: 'Из шаблона',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Выполнить deploy',
      error: 'Deploy не удался',
      compatNote: 'QuickDeploy требует шаблон, совместимый с QuickDeploy: платформа настраивает гостя (сеть, домен, активация) при первом запуске.',
      template: 'Шаблон',
      noTemplates: 'Ни один шаблон пока не декларирует совместимость с QuickDeploy — декларируйте её на вкладке Шаблоны (Linux с cloud-init, Windows с cloudbase-init после sysprep)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Имя хоста',
      hostnameHint: 'Имя хоста или FQDN; пусто = имя VM (Windows: не более 15 символов)',
      ip: 'IP-адрес',
      ipHint: 'Хост и префикс, напр. 192.168.122.101/24; пусто = DHCP',
      gateway: 'Шлюз',
      dns: 'DNS-серверы',
      dnsHint: 'До трёх, через запятую',
      count: 'Экземпляры',
      countHint: 'Больше одного: имена <имя>-1…-N, только DHCP',
      user: 'Пользователь',
      userHint: 'Пусто = пользователь образа по умолчанию (Linux) или Administrator (Windows)',
      password: 'Пароль',
      passwordHint: 'Записывается в сгенерированный user-data, который платформа затем объявляет секретным: никто его больше не прочитает',
      sshKeys: 'Публичные ключи SSH',
      sshKeysHint: 'По одному на строку (ssh-ed25519 AAAA… комментарий)',
      productKey: 'Ключ продукта Windows',
      kmsServer: 'Сервер KMS',
      kmsHint: 'Хост или хост:порт — требует ключ продукта (клиентский ключ KMS)',
      adDomain: 'Присоединить к домену Active Directory',
      adDomainHint: 'Пусто = без присоединения к домену',
      adUser: 'Учётная запись для присоединения',
      adPassword: 'Пароль учётной записи для присоединения',
      adOu: 'Целевая OU (необязательно)',
      advanced: 'Дополнительно: сырые документы',
      userData: 'user-data (сырой)',
      userDataHint: 'Заменяет сгенерированный user-data: пользователь, пароль, ключи и поля Windows выше должны остаться пустыми',
      networkConfig: 'network-config (сырой)',
      networkConfigHint: 'Заменяет сгенерированную сеть: IP, шлюз и DNS выше должны остаться пустыми',
      secret: 'Считать сырой user-data секретным',
      secretHint: 'Помеченный секретным, он больше не возвращается API никому и путешествует в Checkpoint запечатанным masterpass',
      startNow: 'Запустить сразу',
      startNowHint: 'Каждый экземпляр запускается, как только определён; seed создаётся при этом запуске'
    },

    create: {
      nicAttachmentNetwork: 'Логическая сеть (fabric)',
      nicNetwork: 'Логическая сеть',
      nicNetworkHint: 'РЕКОМЕНДУЕМЫЙ путь (F3): vNIC реализуется на ПРОИЗВОДНОМ мосту обслуживающего узла — мост рождается при явном apply fabric, а запуск на узле, который его ещё не несёт, отказывает говоря. Когда уходит последняя ссылка флота, мост выпадает при следующем apply.',
      button: 'Создать ВМ',
      title: 'Создать виртуальную машину',
      dialogTitle: 'Создание виртуальной машины',
      stepGeneral: 'Общее',
      stepGeneralHint: 'Имя и профиль',
      stepCompute: 'CPU и RAM',
      stepComputeHint: 'Топология и размеры',
      stepDisks: 'Диски',
      stepDisksHint: 'Создать или подключить',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Приводы и носители',
      stepNetwork: 'Сеть',
      stepNetworkHint: 'NIC: транк или бридж',
      stepSummary: 'Сводка',
      stepSummaryHint: 'Проверить и создать',
      name: 'Имя',
      nameHint: 'Строчные буквы, цифры и дефисы (DNS-1123)',
      nextButton: 'Далее',
      prevButton: 'Назад',
      submitButton: 'Создать',
      creating: 'Создание…',
      sockets: 'Сокеты',
      cores: 'Ядер на сокет',
      threads: 'Потоков на ядро',
      totalVcpus: 'Всего vCPU',
      memoryGib: 'Память (GiB)',
      cpuModelHint: 'Значение host показывает CPU хоста',
      cpuLimitHint: 'Потолок в ядрах хоста — пусто = без ограничения',
      cpuNestedHint: "Открывает гостю vmx/svm, чтобы он мог запускать собственный гипервизор — требуется модель CPU host и узел с включённым nested",
      newDisk: 'Новый диск',
      attachDisk: 'Подключить существующий диск',
      diskStorage: 'Хранилище',
      diskSize: 'Размер (GiB)',
      diskSelect: 'Диск',
      addDisk: 'Добавить диск',
      addCdrom: 'Добавить привод CD/DVD',
      addNic: 'Добавить сетевой интерфейс',
      remove: 'Убрать',
      slotLimit: 'Достигнут предел слотов',
      cdromImage: 'Образ (без него привод остается пустым)',
      nicAttachment: 'Подключение',
      nicAttachmentTrunk: 'Транк оверлея',
      nicAttachmentBridge: 'Бридж хоста',
      nicUntagged: 'Нетегированный оверлей',
      nicUntaggedNone: 'Нет (только тегированные)',
      nicTrunkHint: 'Хотя бы одна сторона: нетегированный оверлей и (или) сопоставления тегированных VLAN — ВМ может работать только на хостах, объявленных каждым упомянутым оверлеем',
      nicTaggedVlan: 'ID VLAN',
      nicTaggedOverlay: 'Оверлейная сеть',
      addTagged: 'Добавить тегированный VLAN',
      nicBridge: 'Имя бриджа хоста',
      nicBridgeHint: 'Бридж NM по имени — ВМ может работать только на серверах, чья хостовая сеть объявляет этот бридж',
      nicMac: 'MAC (автоматически, если пусто)',
      noDisksHint: 'Дисков нет: у ВМ будут только приводы CD/DVD, которые вы добавите.',
      noCdromsHint: 'Приводов CD/DVD нет: добавьте один, чтобы загрузиться с образа ISO.',
      mountGuestTools: 'Смонтировать TVirt Guest Tools при первом запуске',
      mountGuestToolsHint: 'Кладет ISO с драйверами virtio и гостевым агентом в пустой привод CD (он добавляется, если нужно) — установщику Windows это необходимо, чтобы увидеть диски.',
      noNicsHint: 'Сетевых интерфейсов нет: ВМ запустится без связи.',
      taggedMappings: 'Сопоставления тегированных VLAN',
      summaryDevices: 'Устройства',
      bootOrderTitle: 'Порядок загрузки',
      bootOrderHint: 'Перетащите, чтобы изменить порядок — побеждает первое загружаемое устройство; NIC загружают по PXE',
      bootOrderUp: 'Переместить вверх',
      bootOrderDown: 'Переместить вниз',
      createError: 'Создание не удалось'
    },
    edit: {
      button: 'Изменить',
      title: 'Изменить виртуальную машину',
      cancel: 'Отмена',
      save: 'Сохранить',
      error: 'Изменение не удалось',
      modelStoppedOnly: 'Изменяется только на выключенной ВМ',
      firmwareStoppedOnly: 'Прошивка меняется только на выключенной ВМ — при следующем запуске машина стартует с новой прошивкой, а переменные UEFI сохраняются',
      hugePagesStoppedOnly: 'Изменяется только на выключенной ВМ — при следующем запуске память рождается на новой основе',
      runningHint: 'Изменения применяются при следующем цикле питания',
      sectionCpu: 'CPU',
      sectionMemory: 'Память',
      sectionPolicy: 'Политики'
    },
    devices: {
      networkChip: 'сеть fabric',
      title: 'Устройства',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Добавить устройство USB',
      addUsbTitle: 'Запросить класс устройств USB',
      usbClassHint:
        'ВМ запрашивает КЛАСС устройств USB (значение тега usb-device), а не конкретное устройство: при запуске на узле выбирается и резервируется конкретное свободное устройство. Тегируйте зарегистрированные устройства в разделе «Кластер › Ресурсы USB и PCIe».',
      usbTag: 'Тег (usb-device)',
      usbValue: 'Значение класса',
      noUsbTags: 'Тега usb-device нет — создайте его и тегируйте зарегистрированные устройства в разделе «Кластер › Ресурсы USB и PCIe».',
      noUsbValues: 'У этого тега еще нет объявленных значений.',
      usbEmpty: 'Требований USB нет — добавьте класс, чтобы пробросить устройство при запуске.',
      usbClassChip: 'класс',
      usbPortChip: 'порт',
      usbUnclaimed: 'Ни одно устройство не зарезервировано — это решается при запуске ВМ.',
      addGpu: 'Добавить GPU',
      addGpuTitle: 'Запросить класс GPU',
      gpuClassHint:
        'ВМ запрашивает КЛАСС GPU (значение тега gpu-device), а не конкретную карту: при запуске на узле выбирается и резервируется конкретная свободная карта, и вместе с ней ЦЕЛИКОМ пробрасывается вся ее группа IOMMU. Тегируйте зарегистрированные GPU в разделе «Кластер › Ресурсы USB и PCIe».',
      gpuTag: 'Тег (gpu-device)',
      gpuValue: 'Значение класса',
      noGpuTags: 'Тега gpu-device нет — создайте его и тегируйте зарегистрированные GPU в разделе «Кластер › Ресурсы USB и PCIe».',
      noGpuValues: 'У этого тега еще нет объявленных значений.',
      gpuEmpty: 'Требований GPU нет — добавьте класс, чтобы пробросить карту при запуске.',
      gpuClassChip: 'класс',
      gpuGroupChip: 'группа IOMMU ×',
      gpuUnclaimed: 'Ни одна карта не зарезервирована — это решается при запуске ВМ.',
      gpuPowerCycle: 'Горячего подключения GPU нет — изменения действуют со следующего цикла питания (PendingRestart)',
      actions: 'Действия',
      attachDisk: 'Добавить диск',
      attachDiskTitle: 'Добавление диска',
      attach: 'Подключить',
      noFreeDisks: 'Неиспользуемых дисков нет — создайте один в разделе «Виртуальные машины › Неиспользуемые диски».',
      addCdrom: 'Добавить привод',
      addCdromTitle: 'Добавление привода CD/DVD',
      editCdromTitle: 'Смена образа CD/DVD',
      changeMedia: 'Сменить образ CD/DVD',
      ejectMedium: 'Извлечь',
      mountGuestTools: 'Смонтировать TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools смонтированы',
      guestToolsClickMount: 'Кладет ISO TVirt Guest Tools в первый пустой привод CD/DVD',
      guestToolsClickUnmount: 'Нажмите, чтобы извлечь — привод останется, пустой',
      guestToolsNoSlot: 'Пустого привода CD/DVD нет — добавьте привод (или извлеките носитель), чтобы смонтировать TVirt Guest Tools',
      guestToolsSkew: 'Смонтирована v{pinned}; узел {node} теперь предоставляет v{current}: извлеките и смонтируйте заново для обновления',
      ejectGuestTools: 'Извлечь TVirt Guest Tools (привод останется, пустой)',
      guestToolsEjectConfirmTitle: 'Извлечь TVirt Guest Tools?',
      guestToolsEjectConfirmBody: 'Носитель извлекается из включенной ВМ — привод CD/DVD останется, пустой.',
      applyLive: 'Применить сразу (ВМ включена)',
      addNic: 'Добавить интерфейс',
      addNicTitle: 'Добавление сетевого интерфейса',
      editNicTitle: 'Изменение сетевого интерфейса',
      bridgeChip: 'бридж',
      cable: 'Виртуальный кабель',
      plug: 'Подключить виртуальный кабель',
      unplug: 'Отключить виртуальный кабель',
      remove: 'Убрать',
      removeTitle: 'Убрать {device}?',
      removeBody: 'На включенной ВМ изменение применяется при следующем цикле питания. Диски и образы отключаются, но никогда не удаляются.'
    }
  }
}
